module.exports = __webpack_public_path__ + "img/appAsset-brand--Office365.77a5b2e1.svg";